import HfMarked from "../../hf-marked";
import {Link} from "react-router-dom";
import React from "react";

export default function ToolDetail({tool, isLoading}: { tool: Tool | null, isLoading: boolean }) {
    if (isLoading) {
        return (<p>Loading...</p>);
    } else if (tool === null) {
        return (<p>Tool not found</p>);
    } else {
        return (<>
            <div>
                <h1>{tool?.name}</h1>
                <p className="text-8 mt-8">{tool?.description}</p>
            </div>

            <div>
                <h2>Tips</h2>
                <HfMarked>{tool?.tips}</HfMarked>
            </div>

            <div>
                <h2>Recipes <small>using this tool</small></h2>

                <ul className="list-disc">
                    {tool?.recipes?.filter(rt => rt.recipe).map(rt => (
                        <li key={rt.recipe!.publicId}>
                            <p>
                                <Link to={"/cooking/recipe/" + rt.recipe!.publicId}>
                                    {rt.recipe!.name}
                                </Link>
                            </p>
                        </li>
                    ))}
                </ul>
            </div>

            <div>
                <p className="text-8 text-sm">PublicID {tool?.publicId}</p>
                <p className="text-8 text-sm">Created {tool?.createdAt.toString()}</p>
                <p className="text-8 text-sm">Last Updated {tool?.updatedAt.toString()}</p>
            </div>
        </>);
    }
}